import { render, staticRenderFns } from "./MobileWidget.vue?vue&type=template&id=0e5a84a0&scoped=true&"
import script from "./MobileWidget.vue?vue&type=script&lang=js&"
export * from "./MobileWidget.vue?vue&type=script&lang=js&"
import style0 from "./MobileWidget.vue?vue&type=style&index=0&id=0e5a84a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a84a0",
  null
  
)

export default component.exports